import { InputAdornment } from '@material-ui/core';
import ClearIcon from '@material-ui/icons/Clear';
import * as React from 'react';
import styled from 'styled-components';
import { DSTextFieldProps, DSTextField } from '../../../mui';
import { DSIconButton } from '../../Buttons';

const StyledAdornment = styled(InputAdornment)`
    min-width: 24px;
`;

export type SearchInputProps = Pick<DSTextFieldProps, 'fullWidth' | 'label' | 'placeholder' | 'value' | 'variant'> & {
    alwaysShowClear?: boolean;
    'data-cy'?: string;
    onChange: (value: string) => void;
};

export function SearchInput({ alwaysShowClear = false, onChange, ...props }: SearchInputProps): JSX.Element {
    const isValueSet = alwaysShowClear || (typeof props.value === 'string' && props.value !== '') || !!props.value;
    return (
        <DSTextField
            InputProps={{
                endAdornment: (
                    <StyledAdornment position="end">
                        {isValueSet && (
                            <DSIconButton edge="end" size="small" onClick={() => onChange('')}>
                                <ClearIcon />
                            </DSIconButton>
                        )}
                    </StyledAdornment>
                ),
            }}
            variant="outlined"
            onChange={event => onChange(event.target.value)}
            {...props}
        />
    );
}
SearchInput.displayName = 'SearchInput';
